import React from 'react';
import '@/assets/styles/ProfilePage.css';

function ProfilePage({ user, onBack }) {
	return (
		<div className="profile-container">
			<div className="profile-card">
				<button className="back-btn" onClick={onBack}>⬅ بازگشت</button>
				<h2>پروفایل من</h2>
				<div className="profile-info">
					<p><strong>نام کاربر:</strong> {user?.email || 'کاربر تستی'}</p>
					<p>
						<strong>سطح دسترسی:</strong> {
							{
								high: "بالا (مدیر ارشد)",
								mid: "متوسط (مدیر میانی)",
								specialist: "پیشرفته (کارشناس)",
								basic: "عادی (کارمند)",
								public: "عمومی (شهروند)"
							}[user?.accessLevel] || 'در حال تعیین توسط سیستم...'
						}
					</p>
				</div>
			</div>
		</div>
	);
}

export default ProfilePage;